import type { IRecord } from '@gp/types/global';

export const DEPARTMENT_NAME_MAPS: IRecord<string> = {
  iegg: 'IEGG',
  studio: 'Studio',
};

export const STAKEHOLDERS_SORT_KEYS = ['Project Core Stakeholders', 'Studio-Level Stakeholders'];

export const ORGANIZATIONS_SORT_KEYS = ['iegg', 'studio'];

export const DEPARTMENTS_SORT_KEYS = ['development', 'publishing', 'finance'];

export const STAKEHOLDER_MODULE_KEY_MAPPING = {
  IEGG: 'iegg',
  STUDIO: 'studio',
};
